import React from "react";
import { Quote } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  quote: "NAVIS ha trovato il yacht perfetto per le mie esigenze, con un servizio impeccabile e molta discrezione.",
  author: "Marco B.",
  position: "Cliente soddisfatto",
  isElite: false,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_1.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_1.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_1.png-wvc-sizes",
    alt: "Interno yacht di lusso in bianco e nero"
  }
}, {
  quote: "Professionalità e competenza che si percepiscono in ogni fase del processo di acquisto e noleggio.",
  author: "Lucia R.",
  position: "Cliente Elite",
  isElite: true,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_2.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_2.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_interior_bw_2.png-wvc-sizes",
    alt: "Dettaglio architettonico yacht in bianco e nero"
  }
}];
export default function VociDalMare() {
  return <section id="voci-dal-mare" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground tracking-tight">
            Voci dal Mare
          </h2>
          <div className="w-24 h-1 bg-secondary mx-auto mt-6"></div>
        </div>

        <div className="space-y-32">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} className={`flex flex-col gap-12 md:gap-24 items-center ${i % 2 !== 0 ? "md:flex-row-reverse" : "md:flex-row"}`}>
              {}
              <div className="flex-1 relative w-full">
                <Quote className="absolute -top-12 -left-8 w-32 h-32 text-muted/50 -z-10 rotate-180" aria-hidden="true" />
                
                <blockquote className="relative z-10">
                  <p className="font-medium italic font-default text-foreground leading-relaxed mb-10 !text-xl">
                    "{testimonial.quote}"
                  </p>
                </blockquote>

                <div className="flex flex-wrap items-center gap-6">
                  <div>
                    <p className="font-bold font-default text-xl text-foreground uppercase tracking-wide">
                      {testimonial.author}
                    </p>
                    <p className="text-muted-foreground mt-1">
                      {testimonial.position}
                    </p>
                  </div>
                  
                  {testimonial.isElite && <Badge variant="outline" className="border-secondary text-secondary bg-secondary/5 px-4 py-1.5 text-sm uppercase tracking-wider font-semibold">
                      Cliente Elite Verificato
                    </Badge>}
                </div>
              </div>

              {}
              <div className="flex-1 w-full">
                <div className="aspect-[4/5] md:aspect-[3/4] overflow-hidden rounded-lg relative shadow-2xl">
                  <img src={testimonial.image.src} data-wvc-srcset={testimonial.image.srcset} data-wvc-sizes={testimonial.image.sizes} alt={testimonial.image.alt} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-in-out" loading="lazy" />
                  {}
                  <div className="absolute inset-0 bg-foreground/5 pointer-events-none"></div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}